"use strict";
const jsxRuntime = require("react/jsx-runtime");
const React = require("react");
const foundations_typography_Text_Text = require("../foundations/typography/Text/Text.js");
const alert = "_alert_10xbi_1";
const alertMain = "_alertMain_10xbi_17";
const alertTitle = "_alertTitle_10xbi_24";
const alertContent = "_alertContent_10xbi_25";
const styles = {
  alert,
  alertMain,
  alertTitle,
  alertContent,
  "alert-info": "_alert-info_10xbi_33",
  "alert-warning": "_alert-warning_10xbi_39",
  "alert-error": "_alert-error_10xbi_45",
  "alert-success": "_alert-success_10xbi_52"
};
const AlertContent = ({ children }) => {
  if (typeof children === "string") {
    return /* @__PURE__ */ jsxRuntime.jsx(foundations_typography_Text_Text.P, { variant: "text-body", className: styles.alertContent, children });
  }
  if (Array.isArray(children)) {
    const allStringsOrNumbers = children.every(
      (child) => typeof child === "string" || typeof child === "number"
    );
    if (allStringsOrNumbers) {
      return /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, { children: children.map((child, index) => /* @__PURE__ */ jsxRuntime.jsx(foundations_typography_Text_Text.P, { variant: "text-body", className: styles.alertContent, children: child }, `alert-${index}`)) });
    } else {
      return /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, { children });
    }
  }
  if (React.isValidElement(children)) {
    return children;
  }
  return null;
};
exports.AlertContent = AlertContent;
exports.styles = styles;
